import BugReportService from './BugReportService.js';

const service = new BugReportService();

export default {
  key: 'bugReport',
  namespaced: true,
  state: {},
  actions: {
    store({commit}, payload = {}) {
      return service.store(payload);
    },
  },
  mutations: {},
};
